'use client'
import { useTranslations } from 'next-intl'
import { useEffect, useState } from 'react'

import type { BoxProps } from '@fortum/elemental-ui'
import { ContentText, spacing } from '@fortum/elemental-ui'

import { BasicAccordion } from '@/shared/components/BasicAccordion'
import type { RichTextDocument } from '@/shared/components/RichText'
import { RichText } from '@/shared/components/RichText'
import { useBreakpoints } from '@/shared/hooks/useBreakpoints'
import { getElementalTheme } from '@/style/theme'

export const QuizAdditionalInfoBox = ({
  additionalInfo,
  ...props
}: { additionalInfo: RichTextDocument | string } & BoxProps) => {
  const { colors } = getElementalTheme()
  const t = useTranslations('quiz')

  const { isMobile } = useBreakpoints()

  const [isExpanded, setExpanded] = useState(false)

  const isRichTextDocument = (doc: RichTextDocument | string): doc is RichTextDocument => {
    return typeof doc === 'object' && doc !== null
  }

  useEffect(() => {
    setExpanded(!isMobile)
  }, [isMobile])

  return (
    <BasicAccordion
      isExpanded={isExpanded}
      panelId="quiz-additional-info-box"
      onToggle={() => setExpanded((prev) => !prev)}
      data-testid="quiz-additional-info-box"
      header={<ContentText size="l">{t('infoLabel')}</ContentText>}
      boxProps={{
        ...props,
        paddingHorizontal: spacing.xs,
        paddingVertical: spacing.xxs,
        backgroundColor: colors.textLightOnDarkSubtle,
        borderRadius: spacing.xxxxs,
        textColor: colors.textLightOnDark,
      }}
    >
      {isRichTextDocument(additionalInfo) ? (
        <RichText document={additionalInfo} />
      ) : typeof additionalInfo === 'string' ? (
        <ContentText>{additionalInfo}</ContentText>
      ) : null}
    </BasicAccordion>
  )
}
